import ResetPasswordModal from './ResetPasswordModal';

export default ResetPasswordModal;
